<div class="cdh-download-initial-dialog-content ">
  <span
    ><h3 class="cdh-download-initial-dialog-title">
      Exporting Customer List
    </h3></span
  >

  <span
    ><h5 class="cdh-download-initial-dialog-sub-title">
      We are generating your customer list as an Excel(XLSX) file. This may take
      a few moments. Your download will start automatically once it's ready
    </h5></span
  >
  <div class="cdh-download-initial-dialog-content-close-button">
    <button epg-button [shape]="'text'" (click)="close()">Close</button>
  </div>
</div>
